import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=77fe508d&scoped=true"
import script from "./Create.ts?vue&type=script&lang=ts&external"
export * from "./Create.ts?vue&type=script&lang=ts&external"
import style0 from "./Create.vue?vue&type=style&index=0&id=77fe508d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe508d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fe508d')) {
      api.createRecord('77fe508d', component.options)
    } else {
      api.reload('77fe508d', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=77fe508d&scoped=true", function () {
      api.rerender('77fe508d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/LOPD/pages/Create/Create.vue"
export default component.exports